import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';

const PrivacyPolicy = () => {
  return (
    <div
      className="min-vh-100 py-5"
      style={{
        background: 'linear-gradient(135deg, #e7f1da 0%, #ACB6E5 100%)',
        color: '#212529',
      }}
    >
      <div className="container">
        {/* Page Heading */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-dark fw-bold display-5">Privacy Policy</h2>
          <p className="text-dark">Your data is safe with us</p>
        </motion.div>

        {/* Content Card */}
        <motion.div
          className="bg-white p-4 rounded-4 shadow-lg"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <section>
            <p>
              At <strong>EESOUQ</strong>, we highly value your privacy and are committed to safeguarding your personal
              information. This Privacy Policy outlines how we handle your data when you access and use our EESOUQ
              Ecommerce platform, including our website (<a href="https://www.eesouq.com">www.eesouq.com</a>) and mobile
              application.
            </p>

            <h4 className="mt-5">Your Information - What We Collect</h4>
            <ul>
              <li>Form submissions during registration or subscription.</li>
              <li>Feedback, reviews, and participation in promotions.</li>
              <li>Support correspondence and communication logs.</li>
              <li>Aggregated demographic or technical info.</li>
              <li>Device and location data via the mobile app.</li>
              <li>Order and transaction details.</li>
              <li>Cookies and technical browser/device data.</li>
            </ul>

            <h4 className="mt-5">How We Use Your Information</h4>
            <ul>
              <li>To deliver products, services, and support.</li>
              <li>To personalize your experience and provide relevant content.</li>
              <li>To fulfill obligations and contracts with you.</li>
              <li>To improve our service quality.</li>
              <li>To notify you about changes and updates.</li>
              <li>To run loyalty programs and offers.</li>
            </ul>

            <h4 className="mt-5">Sharing Your Information</h4>
            <ul>
              <li>With service partners for efficient delivery.</li>
              <li>For marketing, advertising, and promotions.</li>
              <li>In business transfers and restructuring events.</li>
              <li>To comply with legal obligations and enforcement agencies.</li>
            </ul>
            <p>
              External links may have different policies — please review them independently.
            </p>

            <h4 className="mt-5">How We Store Your Information</h4>
            <p>
              Data may be stored globally and retained as long as required. We use industry-standard protections like
              encryption and secure servers.
            </p>

            <h4 className="mt-5">Security Measures We Apply</h4>
            <p>
              Only authorized personnel can access your data. We implement secure technologies, but note that online
              transmission is not completely risk-free.
            </p>

            <h4 className="mt-5">Access and Amendment of Your Information</h4>
            <p>
              You can access, update, or delete your personal info and communication preferences. You may also opt-out
              of promotional emails anytime.
            </p>

            <h4 className="mt-5">Changes to Our Privacy Policy</h4>
            <p>
              We may revise this policy as needed. Updates will be posted, and continued use implies consent.
            </p>

            <h4 className="mt-5">Contact Us</h4>
            <p>
              For concerns, contact us at <strong>[your-email@example.com]</strong>. We're here to help resolve issues
              promptly.
            </p>

            <p className="mt-4">
              Thank you for choosing <strong>EESOUQ Ecommerce</strong>. Your trust matters to us.
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
